export class ServiceCategoryClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/service_categories`;
  }

  async list() {
    const url = this.baseURL;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getServices(id) {
    const url = `${this.baseURL}/${id}/services`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async putOrder(data) {
    const url = `${this.baseURL}/order`;

    const response = await this.httpClient.request("put", url, {
      data
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getLocalization(id, language) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url, {
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async putLocalization(id, params, language) {
    const url = `${this.baseURL}/${id}/translation`;

    const response = await this.httpClient.request("put", url, {
      data: params,
      headers: { "x-accept-language": language }
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/subscriptions/service_categories.js